// ============================================================================
// Table Columns: Queues
// Key: queues
// Generated file. Do not edit manually.
// ============================================================================

// #region Imports
import {
	cellRenderer,
	type EntityTableConfig,
	enumRenderer,
	relationCountRenderer,
} from '../../entity-config-runtime/entity-table-config'
import type {
	ContactCodeTreeQueue,
	ContactCodeTreeSummary,
	QueueSummary,
	TeamQueueResponse,
	TeamSummary,
	UserDto,
	UserQueueDto,
} from '../api/backstage.schemas'
import { ContactCodeType, MediaType } from '../api/backstage.schemas'
// #endregion

// #region Entity List Columns
export const queuesListColumnsConfig = {
	columns: [
		'name',
		'description',
		cellRenderer('wrapUpTimeSeconds', 'number'),
		cellRenderer('sortOrder', 'number'),
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
		relationCountRenderer('userCount', 'users'),
		relationCountRenderer('contactCodeTreeCount', 'contactCodeTrees'),
		enumRenderer('type', MediaType, 'MediaType'),
	],
	actions: [
		{
			type: 'link',
			id: 'id',
			label: 'tables_actions_detail',
			icon: 'ArrowRight',
			style: 'link',
			href: (row: QueueSummary) => `/queues/${row.id}/details`,
		},
	],
} as const satisfies EntityTableConfig<QueueSummary>
// #endregion

// #region Relation List Columns
// #region Relation: ContactCodeTrees
export const queuesRelationsContactCodeTreesAssignedColumnsConfig = {
	columns: [
		'queueName',
		'queueDescription',
		'contactCodeTreeName',
		'modifiedBy',
		cellRenderer('sortOrder', 'number'),
		cellRenderer('modifiedUtc', 'dateTime'),
	],
} as const satisfies EntityTableConfig<ContactCodeTreeQueue>
export const queuesRelationsContactCodeTreesAvailableColumnsConfig = {
	columns: [
		'name',
		cellRenderer('isDefault', 'boolean'),
		cellRenderer('contactCodeCount', 'number'),
		cellRenderer('queueCount', 'number'),
		cellRenderer('childrenCound', 'number'),
		enumRenderer('type', ContactCodeType, 'ContactCodeType'),
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
	],
} as const satisfies EntityTableConfig<ContactCodeTreeSummary>
// #endregion

// #region Relation: Teams
export const queuesRelationsTeamsAssignedColumnsConfig = {
	columns: [
		'teamName',
		'queueName',
		'queueDescription',
		cellRenderer('isActive', 'boolean'),
		cellRenderer('isRequired', 'boolean'),
		enumRenderer('queueType', MediaType, 'MediaType'),
	],
} as const satisfies EntityTableConfig<TeamQueueResponse>
export const queuesRelationsTeamsAvailableColumnsConfig = {
	columns: [
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
		'name',
		cellRenderer('isDefaultTeam', 'boolean'),
		'userGroup',
		'responsibleUserGroup',
		cellRenderer('userCount', 'number'),
		cellRenderer('queueCount', 'number'),
		cellRenderer('skillCount', 'number'),
		cellRenderer('customPageCount', 'number'),
		cellRenderer('skillGroupCount', 'number'),
	],
} as const satisfies EntityTableConfig<TeamSummary>
// #endregion

// #region Relation: Users
export const queuesRelationsUsersAssignedColumnsConfig = {
	columns: [
		'queueName',
		'queueDescription',
		cellRenderer('isActive', 'boolean'),
		cellRenderer('isRequired', 'boolean'),
		'userEmail',
		'userFirstName',
		'userLastName',
		'userLogonName',
		'modifiedBy',
		enumRenderer('type', MediaType, 'MediaType'),
	],
} as const satisfies EntityTableConfig<UserQueueDto>
export const queuesRelationsUsersAvailableColumnsConfig = {
	columns: [
		'firstName',
		'lastName',
		'email',
		cellRenderer('isDisabled', 'boolean'),
		'logonName',
		'extension',
		'customProperty1',
		'customProperty2',
		'customProperty3',
		'customProperty4',
		'customProperty5',
	],
} as const satisfies EntityTableConfig<UserDto>
// #endregion
// #endregion

// #region Client List Columns
export const queuesClientGetColumnsConfig = {
	columns: [
		'queueName',
		'queueDescription',
		cellRenderer('isActive', 'boolean'),
		cellRenderer('isRequired', 'boolean'),
		'userEmail',
		'userFirstName',
		'userLastName',
		'userLogonName',
		'modifiedBy',
		enumRenderer('type', MediaType, 'MediaType'),
	],
} as const satisfies EntityTableConfig<UserQueueDto>
// #endregion

// #region Columns Config Export
export const queuesColumnsConfig = {
	list: queuesListColumnsConfig,
	relations: {
		contactCodeTrees: {
			assigned: queuesRelationsContactCodeTreesAssignedColumnsConfig,
			available: queuesRelationsContactCodeTreesAvailableColumnsConfig,
		},
		teams: {
			assigned: queuesRelationsTeamsAssignedColumnsConfig,
			available: queuesRelationsTeamsAvailableColumnsConfig,
		},
		users: {
			assigned: queuesRelationsUsersAssignedColumnsConfig,
			available: queuesRelationsUsersAvailableColumnsConfig,
		},
	},
	client: {
		get: queuesClientGetColumnsConfig,
	},
} as const
// #endregion
